module.exports = __webpack_public_path__ + "static/media/shape-green.26c97fa1.svg";